// mkt-0920-dev-soft-cap-warnings — the created/cloned-wheel half of the
// shared near-limit mechanism (see utils/nearLimit.js / utils/nearLimitToast.js
// for the storage half).
//
// CreateWheelNavEntry.jsx, FoldersV2/OwnerView.jsx and
// WheelCardThreeDotMenu.jsx each already call canCreateWheel()/canCloneWheel()
// on the action they gate (paidlock-no-pre-wizard-cap-check, PR#4670) — that
// call now also returns `used`/`limit` (Backend, same PR) alongside the
// existing `has_permission` boolean. This is the ONE place that turns those
// two numbers into "should we warn, and what does the warning say", so all
// three call sites stay byte-identical in wording and behaviour.
import { nearLimit } from "./nearLimit";
import { showNearLimitToast } from "./nearLimitToast";

export const CREATED_WHEELS_CAP_KEY = "created-wheels";
export const CLONED_WHEELS_CAP_KEY = "cloned-wheels";

/** The sentence for the soft wheel-cap toast, e.g. "4 of 5 created Wheels used." */
export const wheelCapNearLimitMessage = (used, limit, noun) =>
  `${used} of ${limit} ${noun} used. Upgrade your plan for more room.`;

/**
 * Show the shared near-limit toast for a create/clone-wheel check response,
 * IF the account is approaching (not yet at) that cap. Never blocks the
 * caller — this is called AFTER the caller has already decided to proceed
 * (a 200 has_permission), purely to warn ahead of the next attempt.
 *
 * @param {string} key CREATED_WHEELS_CAP_KEY | CLONED_WHEELS_CAP_KEY — also
 *   the once-per-session dedup key (see showNearLimitToast).
 * @param {string} noun "created Wheels" | "cloned Wheels" — plugged into the
 *   shared message.
 * @param {{used?: number, limit?: number|null}} data the check response's
 *   `data` payload. `limit` is null/undefined for an uncapped tier — never
 *   warns in that case (nearLimit's own contract).
 * @param {function} [onUpgrade] optional in-app upgrade handler.
 */
export const warnIfNearWheelCap = (key, noun, data, onUpgrade) => {
  const used = data && data.used;
  const limit = data && data.limit;
  if (!nearLimit(used, limit)) return;
  showNearLimitToast(key, wheelCapNearLimitMessage(used, limit, noun), onUpgrade);
};
